import React, {useEffect, useRef, useState} from 'react';
import Dialog from '@mui/material/Dialog';
import ButtonGroup from '@mui/material/ButtonGroup';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import styled from "styled-components";
import Btn from "../../Btn";
import Tx from "../../Tx";
import RoiCameraItem from "./RoiCameraItem";
import RoiFloorItem from "./RoiFloorItem";

const WrapperStyled = styled.div`
    min-height: 300px;
    width: 100%;
`;

const ButtonGroupStyled = styled.div`
    margin: 20px auto;
    width: fit-content;
`;

const CameraListStyled = styled.div`
    margin: 0 auto;
    width: 100%;
    display: grid;
    grid-template-columns: 47% 47%;
    grid-gap: 10px;
    justify-content: center;
    padding-bottom: 30px;
`;

const RoiTopCameraDialog = (props) => {
    const wrapperRef = useRef(null);

    const {onClose, camera, edge, saveBoxes} = props;

    const [selectedButton, s_selectedButton] = useState(null);
    const [, s_update] = useState(null);
    const [roiBoxFloor, s_roiBoxFloor] = useState(camera.roiBoxFloor || []); // floor
    const [roiBoxPose, s_roiBoxPose] = useState(camera.roiBoxPose || []); // camera
    const [cameraDotIndex, s_cameraDotIndex] = useState(0);

    const [height, s_height] = useState(0);
    const [width, s_width] = useState(0);

    useEffect(() => {
        s_update(1);
    }, []);

    useEffect(() => {
        if (wrapperRef.current && wrapperRef.current.offsetWidth) {
            s_height(wrapperRef.current.offsetHeight);
            s_width(wrapperRef.current.offsetWidth);
        }
    }, [wrapperRef?.current]);

    const save = () => {
        saveBoxes(roiBoxFloor, roiBoxPose);
        onClose();
    };

    const onCameraAddDot = (dot) => {
        s_cameraDotIndex(cameraDotIndex + 1);
        if (roiBoxPose.length < 4) {
            const newBox = [...roiBoxPose];
            newBox[cameraDotIndex] = {x_percent: dot.x_percent, y_percent: dot.y_percent};
            s_roiBoxPose(newBox);
            if (cameraDotIndex === 3) {
                s_selectedButton(null);
            }
        } else {
            s_selectedButton(null);
        }
    };

    const onMoveCameraDot = dot => {
        if (cameraDotIndex > 0) {
            const newBox = [...roiBoxPose];
            newBox[cameraDotIndex] = {x_percent: dot.x_percent, y_percent: dot.y_percent};
            s_roiBoxPose(newBox);
        }
    };

    const onFloorAddDot = (dot) => {
        s_cameraDotIndex(cameraDotIndex + 1);
        if (roiBoxFloor.length < 4) {
            const newBox = [...roiBoxFloor];
            newBox[cameraDotIndex] = {x_percent: dot.x_percent, y_percent: dot.y_percent};
            s_roiBoxFloor(newBox);
            if (cameraDotIndex === 3) {
                s_selectedButton(null);
            }
        } else {
            s_selectedButton(null);
        }
    };

    const onFloorMoveDot = dot => {
        if (cameraDotIndex > 0) {
            const newBox = [...roiBoxFloor];
            newBox[cameraDotIndex] = {x_percent: dot.x_percent, y_percent: dot.y_percent};
            s_roiBoxFloor(newBox);
        }
    };

    return (
        <Dialog
            open={true}
            maxWidth="xl"
            fullWidth={true}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <WrapperStyled>
                <ButtonGroupStyled>
                    <ButtonGroup variant="contained" aria-label="outlined primary button group">
                        <Btn
                            variant={selectedButton === "camera" ? "outlined" : ""}
                            onClick={() => {
                                if (selectedButton === 'camera') {
                                    s_selectedButton(null);
                                    s_cameraDotIndex(0);
                                } else {
                                    s_selectedButton('camera');
                                    s_roiBoxPose([]);
                                    s_cameraDotIndex(0);
                                }
                            }}
                        >Camera</Btn>
                        <Btn
                            variant={selectedButton === "floor" ? "outlined" : ""}
                            onClick={() => {
                                if (selectedButton === 'floor') {
                                    s_selectedButton(null);
                                    s_cameraDotIndex(0);
                                } else {
                                    s_selectedButton('floor');
                                    s_roiBoxFloor([]);
                                    s_cameraDotIndex(0);
                                }
                            }}
                        >Floor</Btn>
                    </ButtonGroup>
                </ButtonGroupStyled>

                <CameraListStyled
                    ref={wrapperRef}
                >
                    <RoiCameraItem
                        title="Camera"
                        camera={camera}
                        drawBoundingBox={selectedButton === "camera"}
                        box={roiBoxPose}
                        onAddDot={onCameraAddDot}
                        onMoveDot={onMoveCameraDot}
                    />
                    <RoiFloorItem
                        wrapperWidth={width / 2}
                        wrapperHeight={height}
                        drawBoundingBox={selectedButton === "floor"}
                        edge={edge}
                        title="Floor"
                        box={roiBoxFloor}
                        onAddDot={onFloorAddDot}
                        onMoveDot={onFloorMoveDot}
                    />
                </CameraListStyled>
            </WrapperStyled>
            <DialogActions>
                <Button onClick={onClose}><Tx>g.cancel</Tx></Button>
                <Button autoFocus onClick={() => {
                    save();
                }}>
                    <Tx>g.save</Tx>
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default RoiTopCameraDialog;